var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLogoMbc = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 32",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.3,7.7c1.5-3.1,4.8-4.2,10.6-4.2l12.9,0c4.3,0,7.2,0.2,8.9,1.6c1.8,1.4,2.5,3.8,2.2,7.5l-7.5,0c0.1-2.1-1.2-3-3.9-3 l-10.5,0c-4.8,0-6,0.6-6,4.8l0,3.4c0,3.8,1.6,4.6,6,4.6l8.9,0c4.3,0,5.9-0.5,5.8-3.6l7.6,0c0.3,4-0.3,6.6-2.4,8.1 c-1.8,1.4-4.8,1.6-9,1.6l-12.9,0c-3.9,0-6.6-0.2-8.7-1.8c-0.9-0.7-1.5-1.4-1.9-2.3V32H150V0h-44.6L105.3,7.7z M0,3.8l11,0l7,15.2 l6.5-15.2l10.9,0l0,24.4l-1.6,0l-5.7,0l0-17.4L20,28.2l-4.2,0L7.2,10.8l0,17.4l-7.2,0V32h44.6V0H0V3.8z M78.2,9.3L60,9.3l0,4l18.1,0 c1.2,0,1.9-0.7,1.9-2C80.1,10.1,79.3,9.3,78.2,9.3 M52.7,3.8l26.9,0c5.5,0,8.1,2.2,8.1,6.8c0,2.6-1.1,4.2-3.6,5.2 c3.1,0.5,4.4,2.3,4.4,5.8c0,4.7-2.4,6.6-7.8,6.6l-28.1,0l0,3.8h44.6V0H52.7V3.8z M60.1,18.3l0,4.4l18.8,0c1.3,0,2-0.8,2-2.2 c0-1.3-0.8-2.2-2.1-2.2L60.1,18.3z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoMbc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-mbc.b00ec835.svg";
export { ForwardRef as ReactComponent };